import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'; // Ensure vuetify is Vue 3 compatible setup
import router from './router';
// import { createStore } from 'vuex';
// import * as Stores from './stores';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

import 'flag-icons/css/flag-icons.min.css';
import './assets/sass/custom.scss';

import * as echarts from 'echarts';
import themeJson from '@/assets/echarts-themes/oceanic-balanced.json';

echarts.registerTheme(themeJson.themeName, themeJson.theme);


// import VueFullscreen from 'vue-fullscreen';
// import VueLocalStorage from 'vue-localstorage'; // A maintained alternative for Vue 3

// // Vuex store creation
// const store = createStore({
//   modules: {
//     ...Stores
//   },
// });

const app = createApp(App);

// Global plugin usage
app.use(vuetify);
app.use(router);
// app.use(store);
app.use(VueToast);
// app.use(VueFullscreen);

// VueLocalStorage plugin for Vue 3
// app.use(VueLocalStorage, {
//   name: 'ls',
//   bind: true
// });

app.mount('#app');
